import React, { useMemo } from "react";
import { Descriptions } from "antd";
import { connect } from "dva";

const IntegrationInfo = ({ adminShipmentView }) => {
  const adminShipmentData = useMemo(() => adminShipmentView?.data, [adminShipmentView]);

  if (adminShipmentData?.integrationsCount === 0) {
    return <p>Shipment has no active integration.</p>;
  }

  return (
    <Descriptions title="WWL" column={1}>
      <Descriptions.Item key="vpc" style={{ paddingBottom: "0" }} label="VPC">
        {adminShipmentData?.vpc || ""}
      </Descriptions.Item>
      <Descriptions.Item key="railHead" style={{ paddingBottom: "0" }} label="Rail Head">
        {adminShipmentData?.railHead || ""}
      </Descriptions.Item>
      <Descriptions.Item key="carrierCode" style={{ paddingBottom: "0" }} label="Carrier Code">
        {adminShipmentData?.carrierCode || ""}
      </Descriptions.Item>
      <Descriptions.Item key="seqNum" style={{ paddingBottom: "0" }} label="Seq Num">
        {adminShipmentData?.sequenceNumber || ""}
      </Descriptions.Item>
    </Descriptions>
  );
};

export default connect(({ adminShipmentView }) => ({
  adminShipmentView,
}))(IntegrationInfo);
